import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { ClientDashboard } from "@/pages/ClientDashboard";
import { ReviewPage } from "@/pages/ReviewPage";
import { LandingPage } from "@/pages/LandingPage";
import { LoginPage } from "@/pages/LoginPage";
import { AcceptInvitePage } from "@/pages/AcceptInvitePage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";

// Protected Route wrapper for Admin
const AdminRoute = ({ children }) => {
  const role = localStorage.getItem('user_role');
  const token = localStorage.getItem('session_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

// Protected Route wrapper for Client
const ClientRoute = ({ children }) => {
  const role = localStorage.getItem('user_role');
  const token = localStorage.getItem('session_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (role !== 'CLIENT') {
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

// Redirect authenticated users away from login
const PublicOnlyRoute = ({ children }) => {
  const token = localStorage.getItem('session_token');
  const role = localStorage.getItem('user_role');
  
  if (token) {
    if (role === 'ADMIN') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing/Home page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Auth pages - redirects if already logged in */}
        <Route path="/login" element={
          <PublicOnlyRoute>
            <LoginPage />
          </PublicOnlyRoute>
        } />
        <Route path="/forgot-password" element={
          <PublicOnlyRoute>
            <ForgotPasswordPage />
          </PublicOnlyRoute>
        } />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />
        
        {/* Admin Dashboard - Protected for Admin role */}
        <Route path="/admin" element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        } />
        
        {/* Client Dashboard - Protected for Client role */}
        <Route path="/dashboard" element={
          <ClientRoute>
            <ClientDashboard />
          </ClientRoute>
        } />
        
        {/* Customer-facing review page - Public */}
        <Route path="/review/:clinicId" element={<ReviewPage />} />
        
        {/* Catch-all redirect to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
